import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home, Compass } from "lucide-react";

const INK_72 = "var(--ink-72)";
const SEAL = "var(--seal)";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ background: "var(--bg)", color: "var(--ink)" }}
      data-testid="not-found-page"
    >
      <div className="eyebrow inline-flex items-center mb-8">
        <span className="seal-dot mr-2" /> 404 · The page is lost
      </div>

      <h1
        className="font-heading text-[80px] sm:text-[120px] md:text-[160px] leading-[0.9]"
        style={{ fontVariationSettings: "'opsz' 144, 'wght' 450", letterSpacing: "-0.03em" }}
      >
        404.
      </h1>

      <h2
        className="font-heading text-2xl md:text-4xl mt-2 leading-[1.1]"
        style={{ fontVariationSettings: "'opsz' 96, 'wght' 450" }}
      >
        This room is <span className="font-display-italic" style={{ color: SEAL }}>empty.</span>
      </h2>

      <p className="text-sm md:text-base mt-6 max-w-md leading-relaxed" style={{ color: INK_72 }}>
        The page you&apos;re looking for has either been moved, renamed, or never existed. Either way — there&apos;s nothing to find here.
      </p>

      <div className="mt-10 flex flex-col sm:flex-row gap-3">
        <button
          onClick={() => navigate(-1)}
          className="btn-secondary"
          data-testid="not-found-back"
        >
          <ArrowLeft size={13} /> Go back
        </button>
        <button
          onClick={() => navigate("/")}
          className="btn-primary"
          data-testid="not-found-home"
        >
          <Home size={13} /> Back to home
        </button>
        <button
          onClick={() => navigate("/dashboard")}
          className="btn-ghost"
          data-testid="not-found-dashboard"
        >
          <Compass size={13} /> Open dashboard
        </button>
      </div>

      <div className="mt-16 pt-8 text-xs" style={{ color: "var(--ink-55)" }}>
        Lost? <a href="mailto:hello@pintaflow.com" style={{ color: SEAL }}>hello@pintaflow.com</a>
      </div>
    </div>
  );
}
